export default "__VITE_ASSET__$KnVFhtj__"